import Settings from './Settings.vue'
import List from './List.vue'
import New from './New.vue'
import Edit from './Edit.vue'
import Delete from './Delete.vue'
import { Route } from 'vue-router'

export const All = [Settings, List, New, Edit, Delete]

export default {
  Settings,
  List,
  New,
  Edit,
  Delete
}

export const RouteConfig = [
  {
    path: 'clients',
    component: Settings,
    name: 'settings-clients',
    children: [
      {
        path: 'list',
        component: List,
        name: 'settings-clients-list'
      },
      {
        path: ':clientId/edit/',
        component: Edit,
        name: 'settings-clients-edit',
        props: function(route: Route) {
          return { clientId: route?.params?.clientId }
        }
      },
      {
        path: 'new',
        component: New,
        name: 'settings-clients-new'
      },
      {
        path: ':clientId/delete',
        component: Delete,
        name: 'settings-clients-delete',
        props: function(route: Route) {
          return { clientId: route?.params?.clientId }
        }
      },
      {
        path: '',
        component: Settings
      }
    ]
  }
]
